import React from 'react';
import { Chip } from '@mui/material';

// Shared vocabulary for the three-stage approval workflow. Mirrors
// backend/utils/approvalWorkflow.js — the server stays the authority on what is allowed;
// this only decides how it reads.
export const APPROVAL_LABELS = {
  draft: 'Draft',
  pending_review: 'Pending Review',
  pending_approval: 'Pending Final Approval',
  approved: 'Approved',
  rejected: 'Rejected',
};

export const APPROVAL_COLORS = {
  draft: 'default',
  pending_review: 'warning',
  pending_approval: 'info',
  approved: 'success',
  rejected: 'error',
};

export const ApprovalChip = ({ status, size = 'small' }) => (
  <Chip
    label={APPROVAL_LABELS[status] || status || 'Draft'}
    color={APPROVAL_COLORS[status] || 'default'}
    size={size}
  />
);

export default ApprovalChip;
